import { atom } from 'recoil';

export const appBarHeightAtom = atom({
  key: 'appBarHeight',
  default: 0,
});
